import CheckMarkSuccess from "common/components/AnimatedIcons/CheckMarkSuccess/CheckMarkSuccess";
import ErrorMark from "common/components/AnimatedIcons/ErrorMark/ErrorMark";
import FormElement from "common/components/FormElement/FormElement";
import Heading from "common/components/Typography/Heading/Heading";
import React, { useState } from "react";
import { Alert, Button, Col, Container, Row } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import Axios from 'services/BackendApi/BackendApi';
import styles from './SignUpForm.module.scss';
import AnimatedBlocks from "common/components/AnimatedIcons/AnimatedBlocks/AnimatedBlocks";
import { getBadHourAndDayMessage, checkDayAndHour } from "common/helpers/HourAndDayChecker";

export default function SignUpForm(props){
    const submitHandler = (e) => {
        let result = null;
        e.preventDefault();
        if (validateData()){
            actionTx();
        }
    }; 
    const [formErrors,setFormErrors] = useState({
        identifier: false,
        email:false
    });
    const [formData, setFormData] = useState({
        identifier: '',
        email: ''
    });
    const [txData,setTxData] = useState({
        loading:false,
        finalized: false,
        result: false,
        messages: []
    })
    function onchangeInput(evc){
        let newErrors = {...formErrors};
        switch (evc.target.name){
            case "formIdentifier":{
                //console.log(evc.target.value.replace(/[^0-9]/g,""),"Identifier");
                setFormData({...formData,identifier:evc.target.value.replace(/[^0-9Kk]/g,'')});
                newErrors.identifier = false;
            }break;
            case "formEmail":{
                setFormData({...formData,email:evc.target.value});
                newErrors.email = false;
            }break;
        }
        setFormErrors(newErrors);
    }
    function validateData(){
        let newErrors = {...formErrors};
        newErrors.identifier=(formData.identifier.trim()==="");
        newErrors.email = (formData.email.trim()==="");
        setFormErrors(newErrors);
        return !newErrors.identifier && !newErrors.email;
    }
    async function actionTx(){
        if (!txData.loading){
            setTxData({...txData,loading:true});
            const {data} = await Axios.ProveedorSignUp(formData);
            if (data.error && data.error===true){
                setFormErrors({...formErrors,__form_general_error:data.error_log[0]});
                setTxData({loading:false,result:false,finalized:true});
            }else{
                setTxData({loading:false,result:true,finalized: true, messages: data.msg });
            }
           
        }
    }
    if (txData.finalized===true){
        return <div>
                <Heading variant="h2">{
                    (txData.result===true)? "Éxito":"Hubo un error"
                }</Heading>
                <div>
                    {(txData.result===true)? <div>
                        <CheckMarkSuccess />
                        <div>
                            {txData.messages}
                        </div>
                    </div>:
                    <div>
                        <ErrorMark />
                        <div>
                            No se pudo completar la operación.
                            <br />
                            {formErrors.__form_general_error}
                        </div>
                    </div>}
                </div>
                <div>
                    <Link to="/user/login">Regresar</Link>
                </div>
        </div>;
    }
    if (checkDayAndHour()===true)
    return <div>
        <Heading variant="h1">Registro de Proveedores</Heading>
                    <Form onSubmit={submitHandler}>
                    <div><br />
                        Bienvenido al Portal de Obligaciones de Pago de Ingenio Magdalena.<br />
                        Por favor, ingrese los siguientes datos para dar de alta su usuario en el portal. <br />

                        OJO: Ya debe haber completado su proceso de registro como proveedor calificado de Ingenio Magdalena para proceder con este paso.
                        <br />
                        <br />
                    </div>
                    <FormElement 
                          margin="1" 
                          id="formIdentifier" 
                          label="NIT o No. Proveedor" 
                          type="text" 
                          onChange={onchangeInput} 
                          name="formIdentifier" 
                          error={formErrors.identifier}     
                          errorMessage="Por favor ingrese un identificador"                     
                          placeholder="Número de proveedor o NIT"
                          value={formData.identifier}
                    />
                    <FormElement 
                          margin="1" 
                          id="formEmail" 
                          label="E-mail registrado" 
                          type="text" 
                          onChange={onchangeInput} 
                          name="formEmail" 
                          error={formErrors.email}     
                          errorMessage="Por favor ingrese email válido"                     
                          placeholder="Ingrese e-mail resgistrado"
                    /><br />
                    <div className={styles.animationsection}>
                    {
                        
                      (txData.loading == true)? <div className={styles.loadinglogin}> <small><AnimatedBlocks fill="#88c359" stroke="#666" /></small> Registrando proveedor... </div>: ''
                    }
                    </div>
                    <div className={styles.buttonsection}>
                    <Button variant="primary" type="submit">
                        Registrarme
                    </Button></div>
                    </Form>
    </div>;
    else
       return getBadHourAndDayMessage();
}